import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, authHeaders } from '../api/ticketsApi';
import DynamicTicketForm from '../components/DynamicTicketForm';
import { PageHeader, Surface } from '../ui';

function buildInitialForm() {
  return {
    domain: '',
    category: '',
    service: '',
    subject: '',
    description: '',
    priority: 'medium',
    reporter_name: '',
    reporter_phone: '',
    reporter_email: '',
    reporter_department: '',
    contact_method: 'phone',
    product_id: '',
    domain_fields: {},
  };
}

function TicketNewPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState(() => buildInitialForm());
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleFormChange = (updates) => {
    setForm((f) => ({ ...f, ...updates }));
  };

  const step = !form.domain ? 1 : (form.subject ? 3 : 2);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.domain === 'product' && !form.product_id) {
      setError('Please select a product');
      return;
    }
    setSubmitting(true);
    setError(null);

    const payload = {
      domain: form.domain,
      category: form.category,
      service: form.service,
      subject: form.subject,
      description: form.description,
      priority: form.priority,
      reporter: {
        name: form.reporter_name,
        email: form.reporter_email,
      },
      domain_fields: form.domain_fields,
    };
    if (form.domain === 'product' && form.product_id) {
      payload.product_id = form.product_id;
    }

    try {
      const res = await axios.post(`${API}/`, payload, authHeaders());
      const ticketNo = res.data.ticket_no;

      const files = form._attachments || [];
      if (files.length) {
        const token = localStorage.getItem('token');
        for (const file of files) {
          const fd = new FormData();
          fd.append('file', file);
          try {
            // Do NOT set Content-Type manually — axios must add the multipart boundary.
            await axios.post(`${API}/${ticketNo}/attachments`, fd, {
              withCredentials: true,
              headers: { Authorization: `Bearer ${token}` },
            });
          } catch (err) {
            console.error('Attachment upload failed', file.name, err);
          }
        }
      }

      alert(`Ticket created: ${ticketNo}`);
      navigate(`/dashboard/tickets/list/${ticketNo}`, {
        state: { from: '/dashboard/tickets/list' },
      });
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to create ticket');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="tk-form-shell">
      <PageHeader
        title="New Ticket"
        subtitle="Hardware, Software, or App Support — routes to the right team"
      />

      <div className="tk-form-steps" aria-hidden="true">
        <div className={`tk-form-step${step >= 1 ? ' is-active' : ''}`}>
          <span className="tk-form-step-num">1</span>
          Domain
        </div>
        <div className={`tk-form-step${step >= 2 ? ' is-active' : ''}`}>
          <span className="tk-form-step-num">2</span>
          Details
        </div>
        <div className={`tk-form-step${step >= 3 ? ' is-active' : ''}`}>
          <span className="tk-form-step-num">3</span>
          Submit
        </div>
      </div>

      <Surface>
        <DynamicTicketForm
          form={form}
          onChange={handleFormChange}
          onSubmit={handleSubmit}
          submitting={submitting}
          error={error}
        />
      </Surface>
    </div>
  );
}

export default TicketNewPage;
